// @ts-check

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import SolutionsContainer from './SolutionsContainer'
import RenderedSolutionWrapper from './RenderedSolutionWrapper'

const useStyles = makeStyles((theme) => ({
  modelContainer: {
    display: 'flex',
    // flexGrow: 5,
    width: '45vw',
    flexDirection: 'column',
    height: '100vh',
    // fontFamily: '"Kumbh Sans", "Roboto", "Helvetica", "Arial", sans-serif'
  },
  child: {
    height: '50vh',
  },
  // lastChild: {
  //   flexGrow: 0,
  // }
}));

function ModelContainer(props) {
  const styles = useStyles();
  return (
    <div className={styles.modelContainer}>
      <RenderedSolutionWrapper className={styles.child} />
      <SolutionsContainer className={styles.child} />
    </div>
  )
}

export default ModelContainer